module.exports = __webpack_public_path__ + "static/media/geo.3ce9ebb9.svg";